import { useQuery } from '@tanstack/react-query';
import { emailRegex } from '@src/utils/regex';
import { PROFILE_QUERY_KEYS, ProfileQueries } from '@api/services/profile/query';
import { useAuth } from '@api/services/auth/hooks/useAuth';
import { User } from '../types';

export const useUserSearch = (email: string) => {
  const { isAuthenticated } = useAuth();
  return useQuery<User[]>({
    queryKey: [PROFILE_QUERY_KEYS.GET_USER_BASIC_INFO, email],
    queryFn: () => ProfileQueries.getManageAccessUser(email),
    enabled: !!isAuthenticated && emailRegex.test(email),
  });
};
